<button (click)="toggleFullscreen()" class="button" fxFlex="grow" fxHide fxShow.gt-sm mat-button>
  <mat-icon *ngIf="!isFullscreen">fullscreen</mat-icon>
  <mat-icon *ngIf="isFullscreen">fullscreen_exit</mat-icon>
</button>
